/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgUnlock(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M13.752 1.436c1.909.53 3.547 2.035 3.986 4.432a.75.75 0 01-1.476.27c-.328-1.791-1.516-2.869-2.912-3.257-1.421-.396-3.042-.072-4.181.972C7.863 5.049 7.75 6.554 7.75 8.533v1.75H19a2.75 2.75 0 012.75 2.75v7a2.75 2.75 0 01-2.75 2.75H5a2.75 2.75 0 01-2.75-2.75v-7A2.75 2.75 0 015 10.282h1.25v-1.75c0-1.955.069-4.104 1.905-5.787 1.547-1.417 3.712-1.835 5.597-1.31zM5 11.782c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-7c0-.69-.56-1.25-1.25-1.25H5z'
      />
    </svg>
  );
}

export default SvgUnlock;
